"use strict";

/**
 * Check if base64 string.
 * @param {string} base64Str - Base64 representation in string format.
 * @returns {boolean} - True/False if the string is base64.
 */
export default function isBase64(base64Str: string) {
    if (base64Str ==='' || base64Str.trim() ===''){ return false; }
    try {
        return btoa(atob(base64Str)) === base64Str;
    } catch (err) {
        return false;
    }
}